export default "__VITE_ASSET__vhybht6H__"